<template>
  <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.36621 15.0002C4.36621 14.3475 4.89533 13.8184 5.54803 13.8184H24.4571C25.1098 13.8184 25.6389 14.3475 25.6389 15.0002C25.6389 15.6529 25.1098 16.182 24.4571 16.182H5.54803C4.89533 16.182 4.36621 15.6529 4.36621 15.0002Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.0028 4.36377C15.6555 4.36377 16.1846 4.89289 16.1846 5.54559L16.1846 24.4547C16.1846 25.1074 15.6555 25.6365 15.0028 25.6365C14.3501 25.6365 13.8209 25.1074 13.8209 24.4547L13.8209 5.54559C13.8209 4.89289 14.3501 4.36377 15.0028 4.36377Z"
      fill="currentColor"
    />
  </svg>
</template>
